import React, { Component } from 'react';
import DesignationComponent from './components/Designation';
import DesignationsComponent from './components/Designations';
import ReviewSubmissionsComponent from './components/ReviewSubmissions';
import HomePageComponent from './components/HomePage';
import MainMenuComponent from './components/MainMenu';
import AdminComponent from './components/Admin';

import './App.css';
//import { AppContext } from "./libs/contextLib";
//const [isAuthenticated, userHasAuthenticated] = useState(false);

class App extends Component {

  constructor() {
    super();
    // window.globalAppTrackURL = "http://localhost:9000/";
    // window.fileServerURL = "http://localhost:8080/";
    // window.letterServerURL = "http://localhost:8083/";
    window.globalAppTrackURL = "https://acris.nyclpc.com/v1/";
    window.fileServerURL = "https://acris.nyclpc.com/cp/";
    window.letterServerURL = "https://acris.nyclpc.com/notice/";
    this.state = {
      componentName : "homepage",
      lmType : 1,
      lpNumber : 0,
      User: null
    }
  }

  componentDidMount() {

  }

  render() {

    var componentName;
    switch (this.state.componentName) {
      case "submit_designations" :
        componentName = <DesignationsComponent lmType={this.state.lmType}
                           handleDesignationClick={this.handleSelectDesignation.bind(this)} />;
        break;
      case "submit_designation" :
        componentName = <DesignationComponent lpNumber={this.state.lpNumber}
                                              User={this.state.User}
                          handleReturnToList={this.handleReturnToDesignations.bind(this)} />;
        break;
      case "review_submissions" :
        componentName = <ReviewSubmissionsComponent
                                              User={this.state.User}
            />;
        break;
      case "admin" :
        componentName = <AdminComponent />;
        break;
      default :
        componentName = <HomePageComponent />;
        break;
    }

    return (
      <div>
        <table width="100%" border="0"><tbody><tr>
          <td><img src="images/lpcseal.jpeg" alt=""/></td>
          <td align="center"><h1>Notice of designation database</h1></td>
          <td align="right"><img src="images/lpclogo.png" alt=""/></td>
        </tr></tbody></table>
        <hr />
        <table width="100%">
          <tbody><tr>
          <td>&nbsp;&nbsp;</td>
          <td valign="top" width="5%">
            <MainMenuComponent handleClick={this.handleClick.bind(this)}/>
          </td>
          <td>&nbsp;&nbsp;</td>
          <td valign="top">
            {componentName}
          </td>
          </tr></tbody>
        </table>
        <br />
        <hr />
        &nbsp;&nbsp;<i>(c) 2020 New York City Landmarks and Preservation Commission</i>
      </div>

      // <AppContext.Provider value={{ isAuthenticated, userHasAuthenticated }}>
      //   <Routes />
      // </AppContext.Provider>
    )
  }

  //on click in home page
  handleClick (data) {
    this.setState({componentName: data[0], User: data[1]})
  }
  handleSelectDesignation(lmType, lpNumber) {
    this.setState({
      lpNumber: lpNumber,
      lmType : lmType,
      componentName: "submit_designation"
    })
  }
  handleReturnToDesignations() {
    this.setState({componentName: "submit_designations"})
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js